<template>
    <div>
        <b-form-group label="Código Expediente" label-for="expediente">
            <b-form-input v-model="proceedingCode" placeholder="Código Expediente" autocomplete="off" :disabled="disabled"
                          :class="validation ? 'is-invalid': ''"/>
            <small v-if="validation" class="text-danger">
                {{ validation }}</small>
        </b-form-group>
    </div>
</template>

<script>
import {BFormGroup, BFormInput} from 'bootstrap-vue'

export default {
    components: {
        BFormGroup,
        BFormInput,
    },
    props: {
        proceedingCode: {
            type: String,
            default: ''
        },
        validation: {
            type: String,
            default: null
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            localProceedingCode: this.proceedingCode,
        }
    },
    watch: {
        proceedingCode(newVal) {
            this.localProceedingCode = newVal
            this.$emit('update', { proceeding_code: this.localProceedingCode })
        },
    },
}
</script>
